var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5D01",
    d: "M12 18.857a6.857 6.857 0 1 0-6.643-8.571h1.341a5.571 5.571 0 0 1 10.444-.429h-1.43a4.286 4.286 0 0 0-7.642.429h4.358v1.285H7.735c-.042.43-.02.863.065 1.286h9.707a5.572 5.572 0 0 1-10.65 1.286H5.485A6.86 6.86 0 0 0 12 18.857m-6.806-6h1.298a5.6 5.6 0 0 1-.047-1.286H5.16a7 7 0 0 0 .034 1.286M12 16.286a4.29 4.29 0 0 0 3.711-2.143H8.288A4.29 4.29 0 0 0 12 16.286"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgo);
export default __webpack_public_path__ + "static/media/ego.2339d36b10abef1b147850ce6ed2da1f.svg";
export { ForwardRef as ReactComponent };